import { useEffect, useState } from 'react';
import { format, isPast } from 'date-fns';
import { MarketStatus } from '@sportspredict/shared';
import { MARKET_ABOUT_TO_CLOSE_MS } from '@/constants';

export function getMarketStatusLabel(market: any): string {
	if (market.status === MarketStatus.Settled) return 'Settled';
	if (market.status === MarketStatus.Closed) return 'Closed';
	if (market.status === MarketStatus.Queue) return 'Queued';

	if (market.opening_time && !isPast(new Date(market.opening_time))) {
		return 'Opens ' + format(new Date(market.opening_time), "MMM d 'at' h:mm a");
	}

	return 'Open';
}

export function useMarketStatus(market: any, tick: any) {
	const [isMarketAboutToClose, setIsMarketAboutToClose] = useState(false);

	useEffect(() => {
		if (!market) return;

		if (market.closing_date) {
			const closingTime = new Date(market.closing_date).getTime();
			const now = Date.now();
			const diffMs = closingTime - now;

			setIsMarketAboutToClose(diffMs <= MARKET_ABOUT_TO_CLOSE_MS);
		}
	}, [market, tick]);

	const marketStatus = getMarketStatusLabel(market);
	const isMarketOpen = marketStatus === 'Open';
	const isMarketClosed = marketStatus === 'Closed';

	return { marketStatus, isMarketOpen, isMarketClosed, isMarketAboutToClose };
}
